"use strict";
/**
 * Index-addressed mutators for `Record<string, string>` fields edited
 * row-by-row in the Settings UI (e.g. `mapping.map`, `system.config`).
 *
 * All writes go through {@link isSafeRecordKey} so attempts to set a
 * prototype-poisoning key are silently dropped (OWASP A03).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeRecordEntry = exports.updateRecordEntry = exports.appendRecordEntry = void 0;
var ai_hub_settings_safe_records_1 = require("./ai-hub-settings-safe-records");
/**
 * Append a placeholder key/value pair to a record. Skipped if the prefix
 * resolves to a forbidden key (impossible with the default prefixes used
 * in the editor, but defensive).
 */
exports.appendRecordEntry = function (record, prefix) {
    var nextRecord = ai_hub_settings_safe_records_1.cloneRecord(record);
    var suffix = 1;
    var nextKey = prefix + suffix;
    while (Object.prototype.hasOwnProperty.call(nextRecord, nextKey)) {
        suffix += 1;
        nextKey = prefix + suffix;
    }
    if (!ai_hub_settings_safe_records_1.isSafeRecordKey(nextKey)) {
        return nextRecord;
    }
    nextRecord[nextKey] = '';
    return nextRecord;
};
/**
 * Replace a record entry key/value pair by list index. Silently ignores
 * attempts to write a prototype-poisoning key.
 */
exports.updateRecordEntry = function (record, entryIndex, nextKey, nextValue) {
    if (!ai_hub_settings_safe_records_1.isSafeRecordKey(nextKey)) {
        return ai_hub_settings_safe_records_1.cloneRecord(record);
    }
    return Object.entries(record || {}).reduce(function (result, _a, index) {
        var currentKey = _a[0], currentValue = _a[1];
        if (index === entryIndex) {
            result[nextKey] = nextValue;
            return result;
        }
        if (ai_hub_settings_safe_records_1.isSafeRecordKey(currentKey)) {
            result[currentKey] = currentValue;
        }
        return result;
    }, ai_hub_settings_safe_records_1.safeRecord());
};
/**
 * Remove a record entry by list index.
 */
exports.removeRecordEntry = function (record, entryIndex) {
    return Object.entries(record || {}).reduce(function (result, _a, index) {
        var currentKey = _a[0], currentValue = _a[1];
        if (index !== entryIndex && ai_hub_settings_safe_records_1.isSafeRecordKey(currentKey)) {
            result[currentKey] = currentValue;
        }
        return result;
    }, ai_hub_settings_safe_records_1.safeRecord());
};
